import { IJPEGLSEncoder, JPEGLSEncodeOptions } from 'app/interfaces/ImageEncoder';

export default class JPEGLSEncoder implements IJPEGLSEncoder {
  constructor(private encoderModule: JPEGLSModule) {}

  encode(image: Uint16Array, options: JPEGLSEncodeOptions): Promise<Uint8Array> {
    return this.encoderModule.encode(image, options.frameInfo, options.nearlossless);
  }
}
